import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { HttpService } from '@kimaya/ngx-http-service';
import { NgxSvgService } from './services/ngx-svg.service';

@Component({
  selector: 'ngx-svg',
  templateUrl: './ngx-svg.component.html',
  styleUrls: ['./ngx-svg.component.scss'],
})
export class NgxSvgComponent implements AfterViewInit {

  @Input() width: string;
  @Input() height: string;
  @Input() directory = 'assets/svg';
  @Input() image: string;
  @Input() fillColor: string;
  @Input() strokeColor: string;
  @Input() strokeWidth: string;
  @Input() className: string;
  @Input() otherProperties: object;

  @ViewChild('divElementRef') divElementRef: ElementRef;

  constructor(private readonly httpService: HttpService,
              private readonly ngxSvgService: NgxSvgService) {
  }

  ngAfterViewInit(): void {
    if (this.ngxSvgService.loadedSvgs[this.image]) {
      this.divElementRef.nativeElement.innerHTML = this.ngxSvgService.loadedSvgs[this.image];
      this.setProperties();
    } else {
      const url = `${this.directory}/${this.image}.svg`;
      this.httpService.getFromUrl(url,
        null,
        null,
        null,
        {
          Accept: 'image/svg+xml',
        },
        'text' as any
      ).subscribe((response: string) => {
        this.ngxSvgService.loadedSvgs[this.image] = response.trim();
        this.divElementRef.nativeElement.innerHTML = response.trim();
        this.setProperties();
      });
    }
  }

  setProperties(): void {
    const firstChild = this.divElementRef.nativeElement.lastChild as SVGElement;
    if (firstChild instanceof SVGElement) {
      this.setPropertyValue(firstChild, 'width', this.width);
      this.setPropertyValue(firstChild, 'height', this.height);
      this.setPropertyValue(firstChild, 'fill', this.fillColor);
      this.setPropertyValue(firstChild, 'stroke', this.strokeColor);
      this.setPropertyValue(firstChild, 'stroke-width', this.strokeWidth);
      const classValue = `${firstChild.getAttribute('class')} ngx-svg-element ${this.className}`;
      firstChild.setAttribute('class', classValue);
      if (typeof this.otherProperties === 'object') {
        for (const otherPropertiesKey in this.otherProperties) {
          if (this.otherProperties.hasOwnProperty(otherPropertiesKey)) {
            this.setPropertyValue(firstChild, otherPropertiesKey, this.otherProperties[otherPropertiesKey]);
          }
        }
      }
    } else {
      console.error(`${this.image} doesn't have proper svg format`);
    }
  }

  setPropertyValue(element: SVGElement, property: string, value: string): void {
    value = value || element.getAttribute(property);
    if (value) {
      element.setAttribute(property, value);
    }
  }

}
